import { useContext } from 'react';

import { Context } from '../context';
import { isWixelRelated } from '../utils/excluded-categories';
import { useStore } from '../zustand/stores';

export const useIxWixelRelated = () => {
  const { pageTemplateData, pageType } = useContext(Context);
  const categoriesTree = useStore((state) => state.categoriesTreeSlice.categoriesTree);

  const shouldHideSearchBar = isWixelRelated(
    pageType,
    categoriesTree,
    pageTemplateData
  );

  return shouldHideSearchBar;
};
